import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import { Box, Stack } from "@mui/material";
import Loading from "../../_components/Loading";
import ProfileMenuList from "./components/ProfileMenuList";
import { useState } from "react";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import robot from "./assets/robot.png";
import Text from "../../_components/Text";
import { useTranslation } from "react-i18next";

const ProfilePage = () => {
  const { t } = useTranslation("profile");
  const user = useSelector((state: RootState) => state.user);

  const [isLoadingAvatar, setIsLoadingAvatar] = useState(true);

  const handleLoading = () => setIsLoadingAvatar(false);

  return (
    <PageLayout
      contentSx={{ padding: "20px 8px 40px" }}
      header={<Header pageTitle={t("profile")} />}
    >
      <>
        <Stack
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          spacing={2}
          sx={{ marginBottom: 3 }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isLoadingAvatar && (
              <Box>
                <Loading size={24} />
              </Box>
            )}
            <img
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 16,
                display: isLoadingAvatar ? "none" : "block",
              }}
              src={robot}
              onLoad={handleLoading}
              alt=""
            />
          </Box>
          <Text variant="h2">{`@${user.telegramUser?.username || "@hamster"}`}</Text>
          <Text variant="s">Since october 2024</Text>
        </Stack>

        <ProfileMenuList />
      </>
    </PageLayout>
  );
};

export default ProfilePage;
